/** @domain participant -- Participant identity and references: participant FK selects, participant name, status, compliance flags. */
import { z } from 'zod';
import { createDomainField, YES_NO_OPTIONS } from './types';

const define = createDomainField('participant');

export const participantId = define({
  label: 'Participant',
  placeholder: 'Select',
  schema: z.string(),
  adapterHint: 'async-select',
  displayFormat: 'text',
});

export const participantName = define({
  label: 'Participant Name',
  schema: z.string(),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const designation = define({
  label: 'Designation',
  schema: z.string(),
  adapterHint: 'text',
  displayFormat: 'text',
});

export const isSection16 = define({
  label: 'Section 16',
  schema: z.boolean(),
  adapterHint: 'checkbox',
  displayFormat: 'boolean',
});

export const isRule144 = define({
  label: 'Rule 144',
  schema: z.boolean(),
  adapterHint: 'checkbox',
  displayFormat: 'boolean',
});

export const section16 = define({
  label: 'Is Section 16',
  schema: z.string(),
  adapterHint: 'radio',
  options: YES_NO_OPTIONS,
  displayFormat: 'boolean',
});

export const rule144 = define({
  label: 'Is Rule 144',
  schema: z.string(),
  adapterHint: 'radio',
  options: YES_NO_OPTIONS,
  displayFormat: 'boolean',
});

export const residentStatus = define({
  label: 'Residence Status',
  placeholder: 'Select',
  schema: z.string(),
  adapterHint: 'async-select',
  displayFormat: 'text',
});

export const transferAgentCompany = define({
  label: 'TA Name',
  placeholder: 'Select',
  schema: z.string(),
  adapterHint: 'async-select',
  displayFormat: 'text',
});

export const taAccountNumber = define({
  label: 'TA Account Number',
  schema: z.string().max(100, 'Must be less than 100 characters'),
  adapterHint: 'text',
  displayFormat: 'text',
});
